import React from "react";
import Layoute from "../components/layoute";
import fetch from "unfetch";
import {
  Pagination,
  Spin,
  Alert,
  notification,
  Upload,
  Input,
  Select,
  Card,
  Col,
  Row,
  Button,
  Icon,
  Divider,
} from "antd";
const Option = Select.Option;
const Dragger = Upload.Dragger;

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      listLoading: true,
      files: [],
      current: 1,
    };
    this.beforeUpload = this.beforeUpload.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
  }

  beforeUpload(file) {
    this.setState({
      file: file,
      loading: true,
    });
    let data = new FormData();
    data.append("file", file);
    fetch("/api/files/upload", {
      credentials: "include",
      method: "POST",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: data,
    })
      .then((r) => r.json())
      .then((res) => {
        this.setState({
          loading: false,
          success: true,
          sent: true,
        });
        this.getFiles();
      });
    return false;
  }

  getFiles() {
    fetch("/api/files", {
      credentials: "include",
      method: "GET",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((r) => r.json())
      .then((res) => {
        this.setState({
          listLoading: false,
          files: res,
        });
      });
  }

  componentDidMount() {
    this.getFiles();
  }

  deleteFile(id) {
    fetch("/api/files/" + id, {
      credentials: "include",
      method: "DELETE",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((r) => r.json())
      .then((res) => {
        this.setState({
          files: this.state.files.filter((f) => {
            return f._id !== id;
          }),
        });
        notification["success"]({
          message: "Suppression effectuée",
          description: "Le fichier a été supprimé",
        });
      });
  }

  downloadFile(name) {
    fetch("/download/" + name).then((res) => {});
  }

  render() {
    return (
      <React.Fragment>
        <h5>Partage de fichiers</h5>
        <p>Espace réservé au partage de fichiers entre membres du bureau</p>
        <Divider />
        <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              paddingRight: "35px",
            }}
          >
            <h5>Liste des fichiers</h5>
            <div
              className={
                "file-list " + (this.state.listLoading ? "loading" : "")
              }
            >
              {this.state.listLoading ? (
                <Spin size="large" />
              ) : (
                this.state.files
                  .slice((this.state.current - 1) * 8, this.state.current * 8)
                  .map((f) => {
                    return (
                      <div className="file">
                        <Icon
                          style={{ fontSize: "50px", color: "#E2001A" }}
                          type={"file" + f.type}
                        />
                        <span className="filename">{f.name}</span>
                        <div className="author">
                          Par {f.author.firstname.substring(0, 1).toUpperCase()}
                          .{f.author.lastname.toUpperCase()}
                        </div>
                        <a
                          download
                          href={"/download/" + f.name}
                          className="download"
                        >
                          <Icon
                            style={{ marginRight: "5px" }}
                            type="download"
                          />
                          Télécharger
                        </a>
                        <a
                          style={{ color: "#585858" }}
                          onClick={() => this.deleteFile(f._id)}
                          className="remove"
                        >
                          <Icon style={{ marginRight: "5px" }} type="delete" />
                          Supprimer
                        </a>
                      </div>
                    );
                  })
              )}
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Pagination
                defaultPageSize={8}
                current={this.state.current}
                total={this.state.files.length}
              />
            </div>
          </div>
          <Dragger
            beforeUpload={this.beforeUpload}
            style={{ flex: 1, height: "100%" }}
            showUploadList={false}
            name="file"
          >
            <p className="ant-upload-drag-icon">
              {this.state.loading ? (
                <Spin size="large" />
              ) : this.state.sent && this.state.success ? (
                <Icon type="check" />
              ) : (
                <Icon type="inbox" />
              )}
            </p>
            {this.state.loading ? (
              <p className="ant-upload-text">Veuillez patienter ...</p>
            ) : this.state.sent ? (
              [
                <p className="ant-upload-text">Fichier envoyé avec succès</p>,
                <p className="ant-upload-hint">
                  Cliquez pour envoyer d'autres fichiers
                </p>,
              ]
            ) : (
              [
                <p className="ant-upload-text">
                  Cliquez ou déposez vos fichiers
                </p>,
                <p className="ant-upload-hint">
                  Une fois votre fichier déposé, il sera accessible à tous
                </p>,
              ]
            )}
          </Dragger>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./components/file-share.js